
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ingredients",
      function () {
        return require("private-next-pages/ingredients.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ingredients"])
      });
    }
  